import { colors } from "@louise/theme/tokens";

export const EMBER = {
  colors: {
    /** @deprecated Was the velvet copper; now the copper accent. Use `accent`. */
    warm: colors.accent,
    warmDark: "#1A0A02", // near-black espresso
    warmLight: "#FDDAB0", // amber glow
    /** @deprecated Was the burnt sienna; now the danger red. Use `danger`. */
    coral: colors.danger,
    teal: "#5E6E3E", // deep olive
    blue: "#6B5A4E", // dark walnut
    /** @deprecated Was the forest; now the success green. Use `success`. */
    green: colors.success,
    /**
     * @deprecated Was the caramel, used for words as well as marks; now the
     * warning's word shade, which reads on cream. Use `warningText` for words
     * and `warning` for icons and fills.
     */
    gold: colors.warningText,
    cryo: "#7A8B8E", // frosted slate — warm-leaning cool tone
    embryo: "#C97B5E", // rose clay
    // The shared text greys: one text palette across the app.
    text: colors.text, // espresso
    textMid: colors.textMid,
    textLight: colors.textLight,
    textFaint: colors.textFaint,
    bg: "#FAF6F2", // cream
    bgEnd: "#F5F0EB",
    border: "#E8E0D8",
    surface: "#FFFFFF",
  },
} as const;

/** Briefly expose the selected state before the next screen enters. */
export const AUTO_ADVANCE_DELAY = 160;
export const ONBOARDING_STEPS = 6; // Welcome doesn't count in step indicator
